/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Magiclinksent2Inputs */

const zh_auth_magiclinksent2 = /** @type {(inputs: Auth_Magiclinksent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录链接已发送`)
};

const en_auth_magiclinksent2 = /** @type {(inputs: Auth_Magiclinksent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magic link sent`)
};

const es_auth_magiclinksent2 = /** @type {(inputs: Auth_Magiclinksent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace mágico enviado`)
};

/**
* | output |
* | --- |
* | "Magic link sent" |
*
* @param {Auth_Magiclinksent2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_magiclinksent2 = /** @type {((inputs?: Auth_Magiclinksent2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Magiclinksent2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_magiclinksent2(inputs)
	if (locale === "en") return en_auth_magiclinksent2(inputs)
	return es_auth_magiclinksent2(inputs)
});
export { auth_magiclinksent2 as "auth_magicLinkSent" }